import { Picture } from './Picture';
import { GeneExpression } from './Gene';
export interface MorphGene {
    gene_name: string,
    gene_type: string,
    is_super: boolean,
    expression: GeneExpression,
    id: number,
}

export interface Morph {
    description: string,
    id: number,
    genes: MorphGene[],
    name: string,
    pictures: Picture[],
    morph_name_id: number,
    reptile: string,
    reptile_name: string
}
export const blankMorph: Morph = {
    description: "",
    id: 0,
    genes: [],
    name: "",
    pictures: [],
    morph_name_id: 0,
    reptile: "",
    reptile_name: ""
}

export const blankMorphGene: MorphGene = {
    id: 0,
    gene_name: '',
    gene_type: '',
    is_super: false,
    expression: 'NORMAL',
}
